import Header from "./header";
import CoursesMenu from "../components/courses-menu";
import PopupsController from "../components/popups-controller";
import ConsultationForm from "./consultation-form";
import ServiceLocator from "../services/service-locator";
import CourseCardsBadges from "./course-cards-badges";
import Consent from "./consent";

export default class CoreModule {
    constructor() {
        this.sl = ServiceLocator.instance;

        this.initConsent();
        this.initHeader();
        this.initCourseMenu();
        this.initPopups();
        this.initConsultationForm();
        this.initCourseCardsBadges();
    }

    initConsent() {
        new Consent();
    }
    initHeader() {
        new Header();
    }

    initCourseMenu() {
        new CoursesMenu();
    }

    initPopups() {
        new PopupsController();
    }

    initConsultationForm() {
        new ConsultationForm();
    }

    initCourseCardsBadges() {
        new CourseCardsBadges();
    }
}